import React from "react";

const PageNotFound = () => <h1>Oops! Cette page n'existe pas.</h1>;

export  default  PageNotFound;